export default {
  site_name: 'MARKJY',
  site_subtitle: '问号盒',
  site_tagline: 'UnknownBox',
  home: '首页',
  blog: '博客',
  contact: '联系方式',
  about: '关于',
  login: '登录',
  signout: '登出',
  logout: '注销',
  register: '注册',
  admin: '管理',
  theme_light: '明亮',
  theme_dark: '暗黑',
  language: '语言',
  username: '用户名',
  password: '密码',
  confirm_password: '确认密码',
  old_password: '旧密码',
  new_password: '新密码',
  submit: '提交',
  cancel: '取消',
  save: '保存',
  edit: '编辑',
  delete: '删除',
  reply: '回复',
  comment: '评论',
  comments: '条评论',
  no_comments: '暂无评论',
  write_comment: '写下你的评论...',
  comment_placeholder: '输入评论内容...',
  comment_username_placeholder: '临时用户名',
  comment_submit: '发表评论',
  comment_count: '条评论',
  reply_count: '条回复',
  load_more: '加载更多',
  no_posts: '暂无文章',
  read_more: '阅读全文',
  back_to_blog: '返回博客',
  publish_date: '发布于',
  update_date: '更新于',
  about_me: '关于我',
  contact_me: '联系我',
  github: 'GitHub',
  email: '邮箱',
  website: '网站',
  all_posts: '全部文章',
  new_post: '新建文章',
  edit_post: '编辑文章',
  post_title: '文章标题',
  post_content: '文章内容',
  manage_posts: '文章管理',
  manage_comments: '评论管理',
  change_password: '修改密码',
  confirm_delete: '确认删除？',
  login_success: '登录成功',
  register_success: '注册成功',
  logout_confirm: '确认注销？',
  password_rule: '密码6-24位',
  username_rule: '用户名最少1汉字或2字母，最多14汉字',
  username_taken: '用户名已被注册',
  username_available: '用户名可用',
  username_temp_taken: '此用户名在当前内容下已被其他人使用',
  rate_limit: '评论频率过高，请10分钟后再试',
  not_found: '页面不存在',
  server_error: '服务器错误',
  network_error: '网络错误',
  login_required: '请先登录',
  admin_required: '需要管理员权限',
  confirm_logout: '确认注销用户？此操作将清除登录状态。',
  logout_with_password: '注销（需输入密码确认）',
  username_alphabetic_start: '用户名不能以数字开头',
  delete_account: '注销账户',
  delete_account_confirm: '此操作不可撤销。请输入密码确认注销：',
  profile: '个人资料',
  contact_content: '如需联系我，请通过以下方式：',
  build_tool: '技术栈',
  delete_post_confirm: '确认删除这篇文章？所有评论也将被删除。',
  delete_comment_confirm: '确认删除此评论？',
  image_upload: '上传图片',
  image_upload_fail: '图片上传失败',
  copy_link: '复制链接',
  copy_code: '复制',
  link_copied: '已复制到剪贴板',
  expand: '展开',
  collapse: '收起',
  view_detail: '查看详情',
  view_replies: '查看回复',
  hide_replies: '隐藏回复',
  write_reply: '写下回复...',
  lang_zh_CN: '简体中文',
  none: '无',
  lang_zh_TW: '繁體中文',
  lang_en: 'English',
}
